export const constants = {
    INITIAL_POSITION_X: 0.5,
    INITIAL_POSITION_Y: 0.0,
    TEXT_MARGIN: 0.125,
    IMAGE_HEIGHT_INCREMENT: 0.2,
    DEFAULT_FONT_SIZE: 7,
    DEFAULT_BORDER_PT: 1,
    DEFAULT_BORDER_COLOR: '000000',
    SLIDE_MARGIN: 1,
    NEWLINE_CHARACTER: '\n',
    DEFAULT_VALIGN: 'top',
    DEFAULT_MARGIN: [0, 0, 0, 10],
    WIDTH_ADJUSTMENT: 0.5,
    POINT_TO_INCH_FACTOR: 1 / 72,
    LINE_LENGTH_TABLE_FACTOR: 300,
    SLIDE_DIMENSION_ABSOLUTE_Y: 5.625,
    SLIDE_DIMENSION_Y: 5.625 - 0.5,
    LINE_HEIGHT_FACTOR: 1.1,
    LINE_HEIGHT_FACTOR_TABLE: 1.2,
    SLIDE_DIMENSIONS: { width: 10, height: 5.625 },
    FILE_NAME: 'chat_export.pptx',
    MAX_LINES_PER_SLIDE: 45,
    TABLE_ROW_HEIGHT: 0.3,
    BOTTOM_MARGIN: 0.3,
    TOP_MARGIN: 0.5,
};
